import { render, staticRenderFns } from "./work_history_new_view.vue?vue&type=template&id=252f0ebc"
import script from "./work_history_new_view.vue?vue&type=script&lang=js"
export * from "./work_history_new_view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports